import { IUser } from '@koopajs/app';
import { IMeeting } from 'types';

export const filterMyMeetings = (user?: IUser) => (meeting: IMeeting) =>
  meeting.participants?.map((participant) => participant.userId).includes(user?.id as string);
